export const countries = [
  {
    label: "England",
    id: "1",
  },
  {
    label: "Scotland",
    id: "2",
  },
  {
    label: "Wales",
    id: "3",
  },
  {
    label: "Northern Ireland",
    id: "4",
  },
];

export const countriesPGAForm = [
  {
    label: "England",
    value: 1,
  },
  {
    label: "Scotland",
    value: 2,
  },
  {
    label: "Wales",
    value: 3,
  },
  {
    label: "Northern Ireland",
    value: 4,
  },
];

export enum AlertTabKey {
  MANUAL_ALERTS = "manual-alerts",
  PGA_UPDATES = "pga-updates",
}

export enum LotDetailTabKey {
  Carcasses = "carcasses",
  Charges = "charges",
  Bonus = "bonus",
  LotInfo = "lotInfo",
}

export const AlertTab = {
  [AlertTabKey.MANUAL_ALERTS]: {
    label: "Manual Alerts",
    typeKey: 1,
  },
  [AlertTabKey.PGA_UPDATES]: {
    label: "PGA Updates",
    typeKey: 4,
  },
};

export enum AlertStatus {
  IN_PROGRESS = "InProgress",
  DONE = "Done",
  FAILED = "Failed",
  READ = "Read",
  NOT_READ = "NotRead",
}

export const DisplayAlertStatus = {
  [AlertStatus.IN_PROGRESS]: {
    label: "Sending",
  },
  [AlertStatus.DONE]: {
    label: "Done",
  },
  [AlertStatus.FAILED]: {
    label: "Failed",
  },
  [AlertStatus.READ]: {
    label: "Read",
  },
  [AlertStatus.NOT_READ]: {
    label: "Not Read",
  },
};
